import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/app.css";
import "./assets/styles/animations.css";
import "./assets/styles/french.css";
import VueTypedJs from "vue-typed-js";

Vue.use(VueTypedJs);

Vue.config.productionTip = false;

window.Event = new Vue();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
